import { render, staticRenderFns } from "./receiveLimitAnalyze.vue?vue&type=template&id=5d771d3c&"
import script from "./receiveLimitAnalyze.vue?vue&type=script&lang=js&"
export * from "./receiveLimitAnalyze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports